import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { ContestsGetResultApi } from 'api-typings/contests/contests';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    contests: ContestsGetResultApi;
  }
}

export const contestsBackend: Backend<'contests'> = {
  fetch: (_, contestIds, query) => ({
    endpoint: `contests/0.1/contests`,
    params: {
      contests: contestIds || [],
      owners: query ? getQueryParamValue(query, 'ownerId') : [],
      /*
        ContestStatus:
            INACTIVE:
              Contest is still in draft and hasn't been paid for.
            ACTIVE:
              Contest is open which means that freelancers may submit entries at any time.
            PENDING:
              Contest goes into pending when duration is over. Contest holder can still award an entry at this point.
            CLOSED:
              Contest is done and has already completed handover process.
            ACTIVE_NOT_EXPIRED:
              Contest is an active design studio contest. This is a contest created from a design project.
      */
      statuses: query ? getQueryParamValue(query, 'status') : [],
      entry_counts: 'true',
    },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contests/contests.backend.ts